import * as Yup from 'yup';
export const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup
  .string()
  .min(6,'Password must be greater than 6 characters')
  .required("Password is required"),
});

